module.exports = {
	baseUrl : '/',
	globalUrl : 'http://localhost:3348/',
	pwa : false
}